import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, MonitorPlay, ArrowRight } from "lucide-react";
import { api, fmtDate, cedi } from "../lib/api";

export const useTrainings = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/trainings").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return rows;
};

const range = (t) => (t.end_date && t.end_date !== t.start_date ? `${fmtDate(t.start_date)} - ${fmtDate(t.end_date)}` : fmtDate(t.start_date));

export const HeroPromo = ({ trainings }) => {
  const t = trainings[0];
  return (
    <a href={t ? "#upcoming" : "#train-your-team"} className="group flex items-center gap-4 bg-[#D4AF37] text-[#14081C] pr-5 hover:bg-[#E3BF45] transition-colors" data-testid="hero-promo">
      <img src={t?.image || "/brand/belt_black.jpg"} alt="" className="w-20 h-16 sm:w-28 sm:h-20 object-cover" />
      <div className="flex-1 min-w-0 py-2">
        <div className="text-[10px] uppercase tracking-[0.22em] font-extrabold">{t ? "Next training" : "Corporate training"}</div>
        <div className="font-display font-bold text-sm sm:text-base truncate">{t ? t.title : "Train your whole team in Lean Six Sigma"}</div>
        <div className="text-xs truncate">{t ? `${range(t)} · ${t.mode}${t.venue ? ` · ${t.venue}` : ""}` : "On-site, classroom or live virtual - request a quote"}</div>
      </div>
      <ArrowRight className="w-5 h-5 shrink-0 group-hover:translate-x-1 transition-transform" />
    </a>
  );
};

export const TrainingCard = ({ t }) => (
  <div className="dx-card overflow-hidden flex flex-col" data-testid={`training-${t.id}`}>
    <div className="relative">
      <img src={t.image} alt={t.title} className="w-full aspect-[16/9] object-cover" />
      {t.highlight && <span className="absolute top-3 left-3 bg-[#D4AF37] text-[#14081C] text-[11px] font-extrabold uppercase tracking-wider px-2.5 py-1">{t.highlight}</span>}
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <h3 className="font-display font-bold text-lg text-[#250E31]">{t.title}</h3>
      <div className="mt-3 space-y-1.5 text-sm text-[#4b3d52] flex-1">
        <div className="flex gap-2"><CalendarDays className="w-4 h-4 text-[#5B2A6E] shrink-0" />{range(t)}{t.schedule ? ` · ${t.schedule}` : ""}</div>
        <div className="flex gap-2"><MonitorPlay className="w-4 h-4 text-[#5B2A6E] shrink-0" />{t.mode}</div>
        {t.venue && <div className="flex gap-2"><MapPin className="w-4 h-4 text-[#5B2A6E] shrink-0" />{t.venue}</div>}
      </div>
      <div className="flex items-center justify-between mt-5">
        <span className="font-display text-xl font-bold text-[#5B2A6E]">{t.price ? cedi(t.price) : ""}</span>
        <Link to="/register?role=staff" className="dx-btn-purple py-2" data-testid={`training-${t.id}-register`}>Register</Link>
      </div>
    </div>
  </div>
);
